import { createPortal } from "react-dom";
import "./stickyCornerAction.scss";

export function StickyCornerAction({ children }: { children: React.ReactNode }) {
    return createPortal(
        <div className="sticky-corner-action">
            {children}
        </div>,
        document.body,
    );
}

